import React from 'react'
import { connect } from 'react-redux'

// ui-kit
import { Row, Col, ContainerFluid } from '@navent-jobs/ui-kit/components/grid'

// mixins
import {
  ModalComponent,
  ModalBodyComponent,
  ModalBodyContent,
  ModalFooterComponent,
  CardContainer,
  CustomLink,
} from './mixins'

import Card from '../../../../components/card'

interface ModalAvisosSugeridosProps {
  subarea: string
  id: string
  width: number
  visible: boolean
  closeModal: Function
  avisosSugeridos: []
  urlMaker: Function
}

const ModalFooter = ({ subareaStringId, closeModal, urlMaker }) => {
  return (
    <ModalFooterComponent>
      <ContainerFluid>
        <Row>
          <Col xs={{ size: 12, order: 2 }} sm={{ size: 6, order: 1 }}>
            <CustomLink
              linkoptions={{ variant: 'primary', type: 'link', size: 'medium', block: true }}
              onClick={closeModal}
            >
              Ver el aviso finalizado
            </CustomLink>
          </Col>

          <Col xs={{ size: 12, order: 1 }} sm={{ size: 6, order: 2 }}>
            <CustomLink
              linkoptions={{ variant: 'primary', type: 'fill', size: 'medium', block: true }}
              href={urlMaker({ subarea: subareaStringId })}
            >
              Ver más avisos
            </CustomLink>
          </Col>
        </Row>
      </ContainerFluid>
    </ModalFooterComponent>
  )
}

const ModalAvisosSugeridos = ({
  subarea,
  width,
  visible,
  closeModal,
  avisosSugeridos,
  urlMaker,
}: ModalAvisosSugeridosProps) => {
  return (
    <ModalComponent
      skin="with-info"
      width={width}
      visible={visible}
      onClose={closeModal}
      title="Este aviso finalizó"
      subtitle="No te preocupes, estas ofertas también pueden coincidir con tu búsqueda."
      footer={<ModalFooter subareaStringId={subarea} closeModal={closeModal} urlMaker={urlMaker} />}
    >
      <ModalBodyComponent>
        <ContainerFluid>
          <Row>
            <Col>
              <ModalBodyContent>
                {avisosSugeridos &&
                  avisosSugeridos.map((aviso, index) => {
                    return (
                      <CardContainer key={aviso}>
                        <Card aviso={aviso} index={index} ubicacion="Modal - Aviso finalizado - Sugeridos" />
                      </CardContainer>
                    )
                  })}
              </ModalBodyContent>
            </Col>
          </Row>
        </ContainerFluid>
      </ModalBodyComponent>
    </ModalComponent>
  )
}

const states = ({ activeAvisoStore }) => ({
  avisosSugeridos: activeAvisoStore.avisosSugeridos,
})

export default connect(states)(ModalAvisosSugeridos)
